import { ProductData } from "../interface";
import { errorHandler } from "./errorHandler";
import { apiRequest } from "./apiRequest";

export const updateWatchList = async (
  id: number,
  args: Partial<ProductData>
): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "patch",
      `/products/add-to-watchlist/${id}`,
      { data: args }
    );
    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to update user");
  }
};
